// created to avoid circular dependencies
export const NAME = 'name';
export const TOKEN = 'token';
export const TYPE = 'type';
export const ANNIVERSARY_YEAR = 'anniversary_year';
export const CONNECTION_ID = 'connection_id';
export const CAMPAIGN_ID = 'campaign_id';
export const SENDER_ID = 'sender_id';
export const CAMPAIGN_IDS = 'campaign_ids';
export const UID = 'uid';
export const STATUS = 'status';
export const NEW_ID = 'new';
